export const convertTenor = (tenors) => {
  let convertedTenors = [
    {
      value: 0,
      label: "Semua",
    },
  ];

  if (!tenors || !tenors.length) return [];

  tenors.forEach((tenor) => {
    convertedTenors.push({
      value: tenor.days,
      label: `${tenor.days} Hari`,
    });
  });
  return convertedTenors;
};
